import { Component, OnInit } from '@angular/core';
import { VcrBaseComponent } from '../vcr-report-base.component';
import { InspectionService } from '../inspection.service';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { MediaObserver } from '@angular/flex-layout';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { ApiService } from '@quorum/api';

@Component({
  selector: 'xsr-vcr-report-display',
  templateUrl: './vcr-report-display.component.html',
  styleUrls: ['./vcr-report-display.component.scss'],
})
export class VcrReportDisplayComponent extends VcrBaseComponent implements OnInit {
  constructor(
    public inspectionService: InspectionService,
    public activatedRoute: ActivatedRoute,
    public authenticationStateService: AuthenticationStateService,
    public mediaService: MediaObserver,
    public breakpointObserver: BreakpointObserver,
    public systemControlStateService: SystemControlStateService,
    public apiService: ApiService
  ) {
    super(
      inspectionService,
      activatedRoute,
      authenticationStateService,
      mediaService,
      breakpointObserver,
      systemControlStateService,
      apiService
    );
  }

  ngOnInit() {
    this.Init();
  }
}
